import React from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const Distribution = ({ content = {} }) => {
  const theme = useTheme();
  const platforms = content.platforms || [];

  return (
    <Box py={{ xs: 2, md: 4 }}>
      <Typography
        variant="overline"
        color="secondary"
        align="center"
        display="block"
        sx={{ fontWeight: 800, letterSpacing: 1.6, mb: 1 }}
      >
        {content.overline}
      </Typography>
      <Typography variant="h3" align="center" gutterBottom sx={{ fontWeight: 800 }}>
        {content.title}
      </Typography>
      <Typography
        variant="h6"
        align="center"
        color="textSecondary"
        sx={{ mb: 2, maxWidth: 760, mx: 'auto', fontWeight: 400, lineHeight: 1.65 }}
      >
        {content.subtitle}
      </Typography>
      <Typography
        align="center"
        color="textSecondary"
        sx={{ mb: 4, maxWidth: 680, mx: 'auto', lineHeight: 1.65 }}
      >
        {content.note}
      </Typography>

      <Grid container spacing={2}>
        {platforms.map((platform) => (
          <Grid item xs={12} sm={6} md={3} key={platform.name}>
            <Box
              data-aos="fade-up"
              sx={{
                height: '100%',
                p: 2.5,
                borderRadius: 3,
                bgcolor: alpha(theme.palette.common.white, 0.88),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.75, lineHeight: 1.3 }}>
                {platform.name}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.6 }}>
                {platform.detail}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

Distribution.propTypes = {
  content: PropTypes.object,
};

export default Distribution;
